import { CLEAR_LOADINGPROGRESS } from "redux/actions/actionTypes"

export const clearLoadingProgress = () => (dispatch, getState) => {
    return dispatch({
        type: CLEAR_LOADINGPROGRESS
    })
}